import { getMissionAccountFilter, getShiftPositionAccountFilter } from '../../../../backend/features/shift';
import { getTrainAccountFilter } from '../../shift/utils/getTrainAccountFIlter';
export const getQualifiedParticipantsFilter = ({ isTrainFeatureEnabled, missionOrganizationSharing, position, deploymentDurations, }) => [
    ...getMissionAccountFilter({ missionOrganizationSharing }),
    ...getShiftPositionAccountFilter({
        deploymentDurations,
        position,
    }),
    ...(isTrainFeatureEnabled && position.trainCourseIds ? getTrainAccountFilter(position.trainCourseIds) : []),
];
